import React, { useCallback } from 'react';
import { Panel, PanelBorderRadius, PanelBorderStyle, PanelTheme } from '@apply/components';
import { DemoPage, DemoPageSection } from './common/DemoLayout';

export const PanelDemo: React.FC = () => {
    const handleDivClick: React.MouseEventHandler = useCallback(() => {
        alert('Div clicked!');
    }, []);

    return (
        <DemoPage title='Panels :'>
            <DemoPageSection title='Color Panels'>
                <Panel
                    theme={PanelTheme.Blue}
                    borderRadius={PanelBorderRadius.Medium}
                >
                    Blue Panel
                </Panel>
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Medium}
                >
                    White Panel
                </Panel>
                <Panel
                    theme={PanelTheme.Red}
                    borderRadius={PanelBorderRadius.Medium}
                >
                    Red Panel
                </Panel>
                <Panel
                    theme={PanelTheme.Gray}
                    borderRadius={PanelBorderRadius.Medium}
                    borderStyle={PanelBorderStyle.Solid}
                >
                    Gray Panel
                </Panel>
                <Panel
                    theme={PanelTheme.Yellow}
                    borderRadius={PanelBorderRadius.Medium}
                    borderStyle={PanelBorderStyle.Solid}
                >
                    Yellow Panel
                </Panel>
            </DemoPageSection>
            <DemoPageSection title='Panel With Sub Panels'>
                <Panel
                    theme={PanelTheme.Blue}
                    borderRadius={PanelBorderRadius.Medium}
                >
                    <div style={{ marginBottom: '1rem' }}>Panel With Sub Panels</div>
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Medium}
                    >
                        Item 1
                    </Panel>
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Medium}
                    >
                        Item 2
                    </Panel>
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Medium}
                    >
                        Item 3
                    </Panel>
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Medium}
                        handleClick={handleDivClick}
                    >
                        Item 4
                    </Panel>
                </Panel>
            </DemoPageSection>
        </DemoPage>
    );
};
